
const PreviewIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={11}
    fill="none"
  >
    <path
      fill="#fff"
      d="M8 .334a7.668 7.668 0 0 1 6.975 4.482l.113.261.006.018c.085.229.096.478.032.712l-.032.1-.006.016a7.667 7.667 0 0 1-6.804 4.738L8 10.666a7.667 7.667 0 0 1-6.974-4.482l-.114-.261-.006-.017a1.166 1.166 0 0 1 0-.811l.006-.018A7.668 7.668 0 0 1 8 .334Zm0 1a6.667 6.667 0 0 0-6.156 4.108l-.01.058c0 .02.002.038.009.057A6.667 6.667 0 0 0 8 9.666l.247-.004a6.667 6.667 0 0 0 5.91-4.105.166.166 0 0 0 0-.115h-.002A6.667 6.667 0 0 0 8 1.334Z"
    />
    <path
      fill="#fff"
      d="M9.5 5.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Zm1 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
    />
  </svg>
)
export default PreviewIcon
